export default {
  about: "Մեր մասին",
  readMore: "Կարդալ ավելին",
};
